import { render, staticRenderFns } from "./ListObservations.vue?vue&type=template&id=20ae76b4&scoped=true&"
import script from "./ListObservations.js?vue&type=script&lang=js&"
export * from "./ListObservations.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae76b4",
  null
  
)

export default component.exports